import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { APP_CONNECT_TYPE } from "../../constants";

import LoginAppleButton from "./button/LoginAppleButton";
import LoginFacebookButton from "./button/LoginFacebookButton";
import LoginGoogleButton from "./button/LoginGoogleButton";
import * as Notification from "../../Notification";
import {
  linkSocialAccount,
  unlinkSocialAccount,
  ssoGetUserInfo,
} from "../../services/app";
import { useApp } from "../../contexts";
import { ModalUnlinkSocialResetPassword } from "./ModalDisconnect";
import { ModalDisconnectWarning } from "./ModalDisconnectWarning";

function ConnectSocial(props) {
  const { state, loadProfile } = props;
  const { T: t, language } = useApp();

  const [openModalResetPassword, $openModalResetPassword] = useState(false);
  const [openModalDisconnectWarning, $openModalDisconnectWarning] = useState(false);
  const [currentProvider, $currentProvider] = useState("");
  const [providerSelected, $providerSelected] = useState("");

  const handleLinkAccount = async (code, provider) => {
    const resLink = await linkSocialAccount({ code, provider }, language);
    if (resLink?.status) {
      Notification.success(t("social_connect_success"));
      loadProfile();
      $openModalResetPassword(false);
    } else {
      Notification.error(t(resLink?.message || "social_connect_error"));
    }
  };
  
  const handleUnlinkAccount = async (provider) => {
    const ssoInfo = await ssoGetUserInfo(language);
    const data = ssoInfo?.data?.data;
    let totalLinked = 0;
    if (data?.apple_id) totalLinked++;
    if (data?.instagram_id) totalLinked++;
    if (data?.google_id) totalLinked++;
    if (data?.facebook_id) totalLinked++;

    if (totalLinked <= 1 && data?.has_password === false) {
      $currentProvider(provider);
      $openModalResetPassword(true);
    } else {
      $providerSelected(provider);
      $openModalDisconnectWarning(true);
    }
  };
  const execUnlinkAccount = async (provider) => {
    const resUnlink = await unlinkSocialAccount({ provider }, language);
    console.log("execUnlinkAccount=>unlinkSocialAccount=", resUnlink);
    if (resUnlink?.status) {
      Notification.success(t("social_disconnect_success"));
      loadProfile();
      $openModalResetPassword(false);
      $openModalDisconnectWarning(false);
    } else {
      Notification.error(t(resUnlink?.message || "social_connect_error"));
      $openModalDisconnectWarning(false);
    }
  };
  const handleError = (error) => {
    Notification.error(t(error || "social_connect_error"));
  };
  const onFinishVerify = (e) => {
    execUnlinkAccount(currentProvider);
    $openModalResetPassword(false);
  };
  useEffect(() => {
    if (openModalResetPassword) {
      document.getElementById("root").classList.add("overflow-hidden");
    } else {
      document.getElementById("root").classList.remove("overflow-hidden");
    }
  });
  return (
    <>
      <div className="flex justify-center lg:justify-start items-start gap-[15px] lg:gap-5">
        <LoginAppleButton
          t={t}
          state={state.appleId}
          onSucess={(e) => handleLinkAccount(e, APP_CONNECT_TYPE.apple)}
          handleRemove={() => handleUnlinkAccount(APP_CONNECT_TYPE.apple)}
          onError={(e) => handleError(e)}
        />
        <LoginFacebookButton
          t={t}
          state={state.facebookId}
          onSucess={(e) => handleLinkAccount(e, APP_CONNECT_TYPE.facebook)}
          handleRemove={() => handleUnlinkAccount(APP_CONNECT_TYPE.facebook)}
          onError={(e) => handleError(e)}
        />
        <LoginGoogleButton
          t={t}
          state={state.googleId}
          onSucess={(e) => handleLinkAccount(e, APP_CONNECT_TYPE.google)}
          handleRemove={() => handleUnlinkAccount(APP_CONNECT_TYPE.google)}
          onError={(e) => handleError(e)}
        />
      </div>
      {openModalResetPassword && (
        <ModalUnlinkSocialResetPassword
          method={currentProvider}
          handleClickClose={() => $openModalResetPassword(false)}
          onFinishVerify={(e) => onFinishVerify(e)}
          handleLinkOther={handleLinkAccount}
          handleError={handleError}
        />
      )}
      {openModalDisconnectWarning && (
        <ModalDisconnectWarning
          onClose={() => $openModalDisconnectWarning(false)}
          onSubmit={() => execUnlinkAccount(providerSelected)}
        />
      )}
    </>
  );
}

ConnectSocial.propTypes = {
  state: PropTypes.object,
  loadProfile: PropTypes.func,
};

export default ConnectSocial;
